<template>
  <Main>
    <v-row class="containerQuotationListAgro">
      <BaseTab class="quotationListAgro__tab px-0 mx-0">
        <v-row>
          <v-col cols="auto" class="quotationListAgro__col">
            <v-tab>COTACOES AGRO</v-tab>
          </v-col>
          <v-spacer class="d-none d-sm-flex" />
          <v-col cols="12" md="auto" class="pb-md-0 d-none d-sm-flex">
            <BaseButton
              class="quotationListAgro__button secondary white--text justify-center"
              width="100%"
              :to="{ name: 'add quotation' }"
            >
              <v-icon class="pr-sm-5 pr-0 pr-md-9">
                fa-plus
              </v-icon>
              NOVA COTACAO
            </BaseButton>
          </v-col>
        </v-row>
        <v-tab-item class="pt-5">
          <QuotationAgroTable />
        </v-tab-item>
      </BaseTab>
    </v-row>
  </Main>
</template>
<script>
import QuotationAgroTable from "../components/QuotationAgroTable";
export default {
  name: "QuotationListAgro",
  data: () => ({}),
  components: {
    QuotationAgroTable
  }
};
</script>
<style lang="sass">
.containerQuotationListAgro
  width: 100% !important
  margin: 0 auto !important
.quotationListAgro__
  &col
    align-self: center
  &tab
    .v-tabs-bar
      height: 50px !important
  &button
    min-height: 44px !important
    height: auto !important
    padding-top: 12px !important
    padding-bottom: 12px !important
    line-height: 1.2 !important
</style>
